/**
 * Shared grid column tracks for both tables. The project table fills the third track
 * (96px) with the 閲覧ユーザー column; the area sub-table leaves it empty so the サイズ /
 * 更新日 / 作成日 columns line up vertically between the two tables.
 *
 * Tracks: chevron · name · viewers · size · updated · created · kebab
 */
export const PROJECT_GRID_COLUMNS = '44px minmax(240px, 1fr) 96px 110px 130px 130px 52px'

export const AREA_GRID_COLUMNS = PROJECT_GRID_COLUMNS
